// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#btn-edit-mode{background-color: #1565c0;}
#btn-edit-mode:hover{background-color: #4fc3f7;}
#btn-edit-mode:active{background-color: #4fc3f7;}
/*#btn-edit-mode:focus{background-color: #4fc3f7;}*/
.select-helper-text {
    color: red;
    text-align: left;
    font-size: 12px;
    float: left;
    padding: 0 12px;
    margin-top: -12px;
}
#btn-select-limit-row {
    float: right;
    width: 100px;
    border: 1px solid #ddd;
    margin-right: 15px;
    font-weight: normal;
}
#btn-select-limit-row .input-field {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
}
#btn-select-limit-row input:not(.browser-default) {
    border-bottom: none !important;
}
#btn-select-limit-row .select-wrapper input.select-dropdown {
    margin: 0;
    padding-left: 0.75rem;
}
#btn-select-limit-row .select-wrapper input.select-dropdown {
    height: 36px;
    line-height: 36px;
}
.btn-delete-single-item .material-icons {
    font-size: 1.8rem;
    color: red;
}
.btn-delete-single-item {
    cursor: pointer;
}
.modal-content strong {
    line-height: 3rem;
    height: 3rem;
    padding-left: 0 !important;
}
.modal-content .row {
    margin-bottom: 5px;
}
.modal-content h4 {
    text-transform: uppercase;
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 30px;
    margin-top: 5px;
}
th {
    padding-top: 0px;
    text-transform: uppercase;
}
th:not(.th-holiday-name) {
    width: 120px;
}
.th-delete, .th-bulk-action {
    text-align: center;
}
td {
    padding: 10px 5px;
}
#form-edit-content, #calendar-form-edit-content {
    margin: 20px 0;
    position: relative;
}
#form-edit-content .input-field, .modal-content .input-field, #calendar-form-edit-content .input-field{
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 15px;
    width: 100%;
}
#form-edit-content .input-field input, #calendar-form-edit-content .input-field input {
    height: 2rem !important;
    font-size: 14px !important;
}
#form-edit-content [type="checkbox"]+span, #calendar-form-edit-content [type="checkbox"]+span{
    padding-left: 27px;
}
ul.dropdown-content {
    max-height: 400px !important;
    top: 44px !important;
    width: auto !important;
    min-width: 100% !important;
}
.modal-content ul.dropdown-content {
    max-height: 300px !important;
}
#dropdown-bulk-action li a{
    font-size: 14px;
    text-align: center;
}
.td-edit-mode {
    position: relative;
}
#btn-create-new {
    position: relative;
    float: right;
    margin-left: 15px; 
}
.grid-container, .filter-inputs {
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    grid-gap: 10px;
}
.grid-container > div, .filter-input-field {
    text-align: center;
    padding: 10px 0;
}
.filter-inputs.row {
    margin-bottom: 0px;
}
.filter-input-field .col {
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
}
#filter-submit {
    line-height: 5rem;
    margin: 0 5px;
    text-align: right;
}
#btn-filter {
    margin-right: 8px;
    padding: 0 10px;
}
#btn-clear-filter {
    padding: 0 10px;
}
#filter-search {
    padding-bottom: 10px;
    border-bottom: 2px dashed #ecebeb;
}
.filter-date {
    width: auto;
    max-width: 160px;
}
#form-filter-search input:not(.browser-default) {
    font-size: 14px;
}
#title-content {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 20px;
    margin-top: 30px;
}
#btn-open-modal-create-calendar, #btn-open-modal-create-item, .btn-open-modal {
    color: #2196f3 !important;
    font-weight: normal;
}
.modal-close {
    color: red
}
#modal-delete-item button {
    text-transform: none;
}
#modal-create-item, #modal-create-calendar, #modal-delete-item {
    max-height: 600px;
    max-width: 600px;
}
#modal-edit-calendar {
    width: 85%;
    max-height: none;
}
input:not(.browser-default):not(.no-default) {
 border-bottom: 1px solid #9e9e9e6e !important;
}
.total-text {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    margin: 0px 5px;
    margin-bottom: 20px;
}
#save-content {
    position: absolute;
    right: 10px;
    top: -12px;
}
#save-status {
    padding: 8px 20px;
    margin: 0px 14px;
}
.table-pagination {
    text-align: center;
    margin-top: 20px;
}
#form-create-item .col.s8, #form-create-calendar .col.s8 {
    padding-right: 0px;
}
.pagination li.active {
    background-color: #40c4ff !important;
}
.modal-done-text {
    margin: 20px 0px;
    font-size: 20px;
    /* font-weight: 500; */
    color: green;
}
.modal-error-text {
    display: inline-block;
    margin-right: 15px;
    font-size: 15px;
    height: 36px;
    color: red;
    line-height: 36px;
    font-weight: 500;
}
@media only screen and (max-width: 800px) {
    .filter-inputs {
        grid-template-columns: auto auto auto;
    }
    #filter-submit {
        text-align: left;
    }
    .filter-date {
        width: auto;
        max-width: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Holiday/style.css"],"names":[],"mappings":"AAAA,eAAe,yBAAyB,CAAC;AACzC,qBAAqB,yBAAyB,CAAC;AAC/C,sBAAsB,yBAAyB,CAAC;AAChD,mDAAmD;AACnD;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,oDAAoD;IACpD,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI;AACJ;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;CACC,6CAA6C;AAC9C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":["#btn-edit-mode{background-color: #1565c0;}\r\n#btn-edit-mode:hover{background-color: #4fc3f7;}\r\n#btn-edit-mode:active{background-color: #4fc3f7;}\r\n/*#btn-edit-mode:focus{background-color: #4fc3f7;}*/\r\n.select-helper-text {\r\n    color: red;\r\n    text-align: left;\r\n    font-size: 12px;\r\n    float: left;\r\n    padding: 0 12px;\r\n    margin-top: -12px;\r\n}\r\n#btn-select-limit-row {\r\n    float: right;\r\n    width: 100px;\r\n    border: 1px solid #ddd;\r\n    margin-right: 15px;\r\n    font-weight: normal;\r\n}\r\n#btn-select-limit-row .input-field {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    padding: 0;\r\n}\r\n#btn-select-limit-row input:not(.browser-default) {\r\n    border-bottom: none !important;\r\n}\r\n#btn-select-limit-row .select-wrapper input.select-dropdown {\r\n    margin: 0;\r\n    padding-left: 0.75rem;\r\n}\r\n#btn-select-limit-row .select-wrapper input.select-dropdown {\r\n    height: 36px;\r\n    line-height: 36px;\r\n}\r\n.btn-delete-single-item .material-icons {\r\n    font-size: 1.8rem;\r\n    color: red;\r\n}\r\n.btn-delete-single-item {\r\n    cursor: pointer;\r\n}\r\n.modal-content strong {\r\n    line-height: 3rem;\r\n    height: 3rem;\r\n    padding-left: 0 !important;\r\n}\r\n.modal-content .row {\r\n    margin-bottom: 5px;\r\n}\r\n.modal-content h4 {\r\n    text-transform: uppercase;\r\n    font-size: 2rem;\r\n    font-weight: 500;\r\n    margin-bottom: 30px;\r\n    margin-top: 5px;\r\n}\r\nth {\r\n    padding-top: 0px;\r\n    text-transform: uppercase;\r\n}\r\nth:not(.th-holiday-name) {\r\n    width: 120px;\r\n}\r\n.th-delete, .th-bulk-action {\r\n    text-align: center;\r\n}\r\ntd {\r\n    padding: 10px 5px;\r\n}\r\n#form-edit-content, #calendar-form-edit-content {\r\n    margin: 20px 0;\r\n    position: relative;\r\n}\r\n#form-edit-content .input-field, .modal-content .input-field, #calendar-form-edit-content .input-field{\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n    font-size: 15px;\r\n    width: 100%;\r\n}\r\n#form-edit-content .input-field input, #calendar-form-edit-content .input-field input {\r\n    height: 2rem !important;\r\n    font-size: 14px !important;\r\n}\r\n#form-edit-content [type=\"checkbox\"]+span, #calendar-form-edit-content [type=\"checkbox\"]+span{\r\n    padding-left: 27px;\r\n}\r\nul.dropdown-content {\r\n    max-height: 400px !important;\r\n    top: 44px !important;\r\n    width: auto !important;\r\n    min-width: 100% !important;\r\n}\r\n.modal-content ul.dropdown-content {\r\n    max-height: 300px !important;\r\n}\r\n#dropdown-bulk-action li a{\r\n    font-size: 14px;\r\n    text-align: center;\r\n}\r\n.td-edit-mode {\r\n    position: relative;\r\n}\r\n#btn-create-new {\r\n    position: relative;\r\n    float: right;\r\n    margin-left: 15px; \r\n}\r\n.grid-container, .filter-inputs {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto auto auto;\r\n    grid-gap: 10px;\r\n}\r\n.grid-container > div, .filter-input-field {\r\n    text-align: center;\r\n    padding: 10px 0;\r\n}\r\n.filter-inputs.row {\r\n    margin-bottom: 0px;\r\n}\r\n.filter-input-field .col {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n    width: 100%;\r\n}\r\n#filter-submit {\r\n    line-height: 5rem;\r\n    margin: 0 5px;\r\n    text-align: right;\r\n}\r\n#btn-filter {\r\n    margin-right: 8px;\r\n    padding: 0 10px;\r\n}\r\n#btn-clear-filter {\r\n    padding: 0 10px;\r\n}\r\n#filter-search {\r\n    padding-bottom: 10px;\r\n    border-bottom: 2px dashed #ecebeb;\r\n}\r\n.filter-date {\r\n    width: auto;\r\n    max-width: 160px;\r\n}\r\n#form-filter-search input:not(.browser-default) {\r\n    font-size: 14px;\r\n}\r\n#title-content {\r\n    text-transform: uppercase;\r\n    font-weight: 500;\r\n    font-size: 20px;\r\n    margin-top: 30px;\r\n}\r\n#btn-open-modal-create-calendar, #btn-open-modal-create-item, .btn-open-modal {\r\n    color: #2196f3 !important;\r\n    font-weight: normal;\r\n}\r\n.modal-close {\r\n    color: red\r\n}\r\n#modal-delete-item button {\r\n    text-transform: none;\r\n}\r\n#modal-create-item, #modal-create-calendar, #modal-delete-item {\r\n    max-height: 600px;\r\n    max-width: 600px;\r\n}\r\n#modal-edit-calendar {\r\n    width: 85%;\r\n    max-height: none;\r\n}\r\ninput:not(.browser-default):not(.no-default) {\r\n border-bottom: 1px solid #9e9e9e6e !important;\r\n}\r\n.total-text {\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    text-transform: uppercase;\r\n    margin: 0px 5px;\r\n    margin-bottom: 20px;\r\n}\r\n#save-content {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: -12px;\r\n}\r\n#save-status {\r\n    padding: 8px 20px;\r\n    margin: 0px 14px;\r\n}\r\n.table-pagination {\r\n    text-align: center;\r\n    margin-top: 20px;\r\n}\r\n#form-create-item .col.s8, #form-create-calendar .col.s8 {\r\n    padding-right: 0px;\r\n}\r\n.pagination li.active {\r\n    background-color: #40c4ff !important;\r\n}\r\n.modal-done-text {\r\n    margin: 20px 0px;\r\n    font-size: 20px;\r\n    /* font-weight: 500; */\r\n    color: green;\r\n}\r\n.modal-error-text {\r\n    display: inline-block;\r\n    margin-right: 15px;\r\n    font-size: 15px;\r\n    height: 36px;\r\n    color: red;\r\n    line-height: 36px;\r\n    font-weight: 500;\r\n}\r\n@media only screen and (max-width: 800px) {\r\n    .filter-inputs {\r\n        grid-template-columns: auto auto auto;\r\n    }\r\n    #filter-submit {\r\n        text-align: left;\r\n    }\r\n    .filter-date {\r\n        width: auto;\r\n        max-width: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
